import { render, staticRenderFns } from "./story_batch_options.vue?vue&type=template&id=328ff54d&lang=pug"
import script from "./story_batch_options.vue?vue&type=script&lang=js"
export * from "./story_batch_options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports